<!-- /src/components/MediaElements/TableOfContents.vue -->
<template>
    <div v-if="tableOfContents" class="table-of-contents">
        <div class="table-of-contents__header" @click="showTable">
            <button class="button button--sm button--accent">
                <span v-if="!showTableOfContents">Show Table of Contents</span>
                <span v-else>Hide Table of Contents</span>
            </button>
        </div>
        <transition name="dropDown">
            <div class="table-of-contents__elements" v-show="showTableOfContents" >
                <div class="description">
                Click items below to skip time.
                </div>
                <ul class="table-of-contents__items">
                    <li
                        class="table-of-contents__item"
                        v-for="(item, i) in tableOfContents"
                        :key="`toc_item_${i}`"
                        @click="jumpToTime(item.starting_timestamp)"
                    >
                        <div class="table-of-contents__itemTitle">
                            {{ item.chapter_titles }}
                        </div>
                        <time class="table-of-contents__itemTime">{{
                            item.starting_point
                        }}</time>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import postMixin from '@/mixins/postMixin'
import { deepSearch } from '@/components/common/utils/helpers.js'

export default {
    name: 'media-table-of-contents',
    data() {
        return {
            showTableOfContents: false,
        }
    },
    
  props: ['post'],

  mixins: [postMixin],

  computed: {
    tableOfContents() {
      let mediaTableOfContents = deepSearch(this.post, [
        'acf',
        'media_table_of_contents',
      ])
      return Array.isArray(mediaTableOfContents) ? mediaTableOfContents : false
    },
  },

  methods: {
    jumpToTime(time) {
      this.$emit('jumpTo', time)
    },

    showTable() {
        this.showTableOfContents = !this.showTableOfContents
    },

  },
}
</script>

<style scoped>

.table-of-contents {
    &__item {
        cursor: pointer;
        font-size: 0.7em;
        background-color: var(--mediumGray);
        color: var(--brandPrimary);
        padding: 0.4rem 0.75rem;
        transition: all 0.25s;
        border-radius: var(--borderRadiusSmall);
        display: grid;
        grid-template-columns: 1fr auto;

        &:hover {
            background-color: var(--brandAccent);
            color: white;
            .table-of-contents__itemTitle {
                color: white;
            }
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    &__items {
        display: grid;
        grid-gap: .5rem;
        margin-bottom: 0;
    }

    &__header {
        display: grid;
        justify-content: start;
        margin-top: 1rem;
    }

    &__itemTitle {
        font-weight: var(--fontWeightBold);
        text-transform: uppercase;
    }
}

.section-header {
    margin-bottom: 0.5rem;
    h3 {
        text-transform: uppercase;
        font-weight: var(--fontWeightBold);
        font-size: 0.7em;
        color: var(--gray);
        margin-bottom: 0;
    }
}
.description {
    font-size: 0.6em;
    color: var(--gray);
    font-style: italic;
    margin-top: .5rem;
    margin-bottom: .25rem;
}

.dropDown-enter-active,
.dropDown-leave-active {
  transition: opacity var(--animationDurationMedium) ease 0.2s,
    transform var(--animationDurationMedium) ease 0.2s;
  will-change: opacity, transform;
}

.dropDown-enter,
.dropDown-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}


</style>
